module.exports = __webpack_public_path__ + "media/images/favicon-d7d4ef0242d1f9882b9a32f5a8eadbd2.ico";